export default __webpack_public_path__ + "static/elisabeth-engel-9c66ad4cd232771f8fc57a5c7359fb40.jpg";